<mat-dialog-content style="background-color: white;">
    <button mat-button style="float: right;" (click)="closeEmailDialog()">x</button>
    <h2 style="text-align: center;margin-bottom: 20px;">Login with Email</h2>
    <div class="container">
        <div class="container__item">
            <form class="form" *ngIf="!isEmailSent">
                <input type="email" required [(ngModel)]="email" class="form__field" placeholder="Your E-Mail Address" />
                <button type="button"  (click)="sendSignInLink()" class="btn btn--primary btn--inside uppercase">Send</button>
            </form>
            <p *ngIf="isEmailSent" class="alert">Email Sent!</p>
        </div>
        <div *ngIf="!isEmailSent" style="margin: 20px;text-align: center;">We will send you a security link in your email address to log you in automatically.</div>
        <div *ngIf="isEmailSent" style="margin: 20px;text-align: center;">We have sent you a security link in your email address to log you in automatically.</div>

    </div>
    <!-- <mat-dialog-actions><button type="submit" (click)="sendSignInLink()">Send Sign-In Link</button></mat-dialog-actions> -->
</mat-dialog-content>